import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { issuesApi } from "api/issuesApi";
import { PaziaFormButton, PaziaTextarea } from "components/atoms";

interface NewCommentFormProps {
  issueId: number;
  onSubmit: (data: NewCommentFormData) => void;
}
export const NewCommentForm = ({ issueId, onSubmit }: NewCommentFormProps) => {
  const methods = useForm<NewCommentFormData>({
    resolver: yupResolver(schema),
  });
  const { handleSubmit, reset } = methods;

  const onSubmitHandler = async (data: NewCommentFormData) => {
    try {
      await issuesApi.comment(issueId, data.newComment);
      onSubmit(data);
    } catch (e) {
      console.error(e);
    }
    reset({ newComment: "" });
  };
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmitHandler)} className="flex flex-col gap-4">
        <PaziaTextarea label="Dodaj komentarz" name={FORM_NAMES.NEW_COMMENT} />
        <div className="ml-auto">
          <PaziaFormButton title="Dodaj" type="success" />
        </div>
      </form>
    </FormProvider>
  );
};

const FORM_NAMES = {
  NEW_COMMENT: "newComment",
} as const;

const schema = yup
  .object({
    [FORM_NAMES.NEW_COMMENT]: yup.string().required(),
  })
  .required();

export type NewCommentFormData = yup.InferType<typeof schema>;
